import { TouchableWithoutFeedback, Keyboard, Platform } from 'react-native'
import React from 'react'

const KeyboardDismissView = ({ children }: { children: React.ReactNode }) => {

    if (Platform.OS === 'web') {
        return children
    }
    return (
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
            {children}
        </TouchableWithoutFeedback>
    )
}

export default KeyboardDismissView